<template>
  <div class="upload">
    <div class="upload-title">
      设置中心
    </div>
    <div>
      <div v-for="(item,index) in settingList">
        <div class="inputDiv" v-if="item.sitType === 'Input'">
          <p>{{ item.sitName }}</p>
          <a-input :placeholder="item.sitName" v-model="settingList[index].sitContext" />
        </div>
        <div class="inputDiv" v-if="item.sitType === 'InputNumber'">
          {{ item.sitName }}
          ￥<a-input-number
            :default-value="1"
            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\$\s?|(,*)/g, '')"
            :step="1"
            v-model="settingList[index].sitNumber"
            class="inputNuber"
          />
        </div>
        <div class="inputDiv" v-if="item.sitType === 'InputNumberB'">
          <p>{{ item.sitName }}</p>
          <a-row>
            <a-col :span="12">
              <a-slider v-model="settingList[index].sitNumber" :min="0" :max="100" :step="0.01"/>
            </a-col>
            <br />
            <a-col :span="4">
              <a-input-number
                v-model="settingList[index].sitNumber"
                :min="0"
                :max="100"
                :step="0.01"
                style="marginLeft: 16px"
              />
            </a-col>
            %
          </a-row>
        </div>
        <div class="inputDiv" v-show="item.sitType === 'Switch'">
          {{ item.sitName }}{{item.sitName.indexOf('是否标准分润') !== -1?'（目前禁用）':''}}
          <a-switch checkedChildren="开" unCheckedChildren="关" :checked="settingList[index].sitNumber===1"
                    @change="updateCherked(index)" :disabled="item.sitName.indexOf('是否标准分润') !== -1"/>
        </div>
      </div>
    </div>
    <div style="padding-top:10px">
      <a-button type="primary" :loading="submitLoading" @click="updateSetting" >
        保存
      </a-button>
      <a-button type="primary" style="margin-left: 50px;" @click="reset">
        恢复
      </a-button>
    </div>
  </div>
</template>

<script>
import {specification,updateListrankALL} from "api/setting"

export default {
  name: "index",
  data() {
    return {
      settingList: [],
      submitLoading: false
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      let that = this
      specification()
        .then(res => {
          console.log(res.data);
          that.settingList = res.data
        })
        .catch(err => {
          that.$message.error("获取失败")
        })
    },
    updateCherked(index) {
      if (this.settingList[index].sitNumber === 0) {
        this.settingList[index].sitNumber = 1
      } else {
        this.settingList[index].sitNumber = 0
      }
    },
    reset(){
      this.query()
    },
    updateSetting(){
      let that = this
      that.submitLoading = true
      updateListrankALL(that.settingList)
        .then(res => {
          console.log(res);
          that.submitLoading = false
          that.$message.success("更新成功")
        })
        .catch(err => {
          that.submitLoading = false
          that.$message.error("更新失败")
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.upload {
  .upload-title {
    font-size: 30px;
    font-weight: 500;
    color: #131212;
  }
}
.inputDiv{
  padding: 10px;
  padding-left: 0px;
  line-height: 30px;
  width: 800px;
  border-bottom: #8f9090 1px solid;
}
.inputNuber{
  width: 120px;
}
</style>
